import { useEffect, useState } from "react"
import TextEditor from "../CGV/component/TextEditor"
import { Backdrop, Button, CircularProgress } from "@mui/material"
import ModaleValidationComponent from "../../shared/components/Modale/modale-validation.component"
import badgeService from "./services/badge.service"
import "./Badge.css"

const BadgeComponent = () => {

    const [badgeExp, setBadgeExp] = useState('')
    const [badgeExpData, setBadgeExpData] = useState<any>()
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const [reload, setReload] = useState(0)
    const [afficheInput, setAfficheInput] = useState(false)

    const handleSave = async () => {
        try {
            setLoading(true)
            const newBadgeExp = {
                explication: badgeExp
            }
            await badgeService.createBadgeExp(newBadgeExp)
            setReload(reload + 1)
        } catch (error) {
            console.log(error)
        }
    }

    const handleDelete = async () => {
        try {
            setLoading(true)
            await badgeService.deleteBadgeExp(badgeExpData._id)
            setReload(reload + 1)
        } catch (error) {
            console.log(error)
        }
    }

    const fetchingData = () => {
        setLoading(true)
        badgeService.getBadgeExp()
            .then((res) => {
                console.log(`GetBadgeExp fetch: ${JSON.stringify(res.data.data)}`)
                if (res.data.data.length === 0) {
                    setBadgeExp('')
                    setAfficheInput(true)
                } else {
                    setBadgeExp(res.data.data[0].explication)
                    setAfficheInput(false)
                }
                setBadgeExpData(res.data.data[0])
                setLoading(false)
            })
            .catch((e) => {
                console.error(e)
                setLoading(false)
            })
            .finally(() => setLoading(false));
        setBadgeExpData({ explication: 'Explication ...'})
    }

    useEffect(() => {
        fetchingData()   
    }, [reload])

    return (
        <div className="flex justify-center flex-col align-center">
            {afficheInput && (
                <TextEditor value={badgeExp} setValue={setBadgeExp} />
            )}
            
            <div className="contenu-badge ml-5">
                {badgeExpData && !afficheInput && (
                    <div dangerouslySetInnerHTML={{ __html: badgeExp }} className="h-[600px] overflow-auto" />
                )}
            </div>
            <div className="my-5 flex justify-center gap-2">
                {afficheInput && (
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => {
                            setReload(reload + 1)
                        }}
                    >
                        Annuler
                    </Button>
                )}
                {!afficheInput && (
                    <Button
                        variant="contained"
                        color="error"
                        onClick={() => { setOpen(true) }}
                    >
                        Supprimer
                    </Button>
                )}

                {!afficheInput && (
                    <Button
                        variant="contained"
                        color="success"
                        onClick={() => setAfficheInput(!afficheInput)}
                    >
                        Modifier
                    </Button>
                )}
                {afficheInput && (
                    <Button
                        variant="contained"
                        color="success"
                        onClick={handleSave}
                        disabled={badgeExp === '' || badgeExp === '<p><br></p>'}
                    >
                        Enregistrer
                    </Button>
                )}
            </div>
            <Backdrop open={loading} sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}>
                <CircularProgress />
            </Backdrop>

            <ModaleValidationComponent
                openModale={open}
                setOpen={setOpen}
                message={`Voulez-vous supprimer les explications du badge?`}
                handleValidate={handleDelete}
            />
        </div>
    )
}

export default BadgeComponent